import { render, staticRenderFns } from "./two-factor.vue?vue&type=template&id=0c7ce274&scoped=true&"
import script from "./two-factor.vue?vue&type=script&lang=js&"
export * from "./two-factor.vue?vue&type=script&lang=js&"
import style0 from "./two-factor.vue?vue&type=style&index=0&id=0c7ce274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ce274",
  null
  
)

export default component.exports